import React from "react";
import "../../styles/components/marketplace-shared.css";

const DetailMetricCard = ({ className = "", label, value, helper }) => (
  <div className={`marketplace-detail-metric ${className}`.trim()}>
    <span>{label}</span>
    <strong>{value}</strong>
    {helper ? <small>{helper}</small> : null}
  </div>
);

export default DetailMetricCard;


